import React, { useState, useEffect } from 'react';
import { Button, Input, Select, message, Form, InputNumber, Row, Col, Spin } from 'antd';
import useWebPost from '../../utils/useWebPost';
import { getobjkeys } from '../../utils/functions';
import FullHeightLayout from '../../components/FullHeightLayout';

import DateInput from '../../components/DateInput';

// 拆分税费列表为数组（数据源）
const taxOptions = [
    '建筑服务（一般计税）增值税',
    '建筑服务（简易计税）增值税',
    '城市维护建设税',
    '教育费附加',
    '地方教育费附加',
    '印花税',
    '水利建设基金',
    '残疾人保障基金',
    '工会经费',
    '滞纳金',
    '企业所得税',
    '个人所得税',
    '其他'
].map((label) => ({ label, value: label })); // 转换为 antd Select 所需的 {label, value} 格式


const ZqdjForm = ({ invoice, myItem, fkey, onSave }) => {
    const [form] = Form.useForm();
    const webPost = useWebPost();

    const [isloading, setIsloading] = useState(false);
    const [djvalue, setDjvalue] = useState({});

    const [lycount, setLycount] = useState(1);
    useEffect(() => {
        if (invoice) {
            form.setFieldsValue(invoice);
            setIsloading(true);
            webPost("invoicezqdj", { invoice_id: invoice.id }).then((res) => {
                if (res) {
                    setLycount(Math.max(res.length,1));
                    const ds = {};
                    for (let i = 0, l = res.length; i < l; i++) {
                        ds[`wjz_no_${i}`] = res[i].wjz_no;
                        ds[`szlx_${i}`] = res[i].szlx;
                        ds[`js_amt_${i}`] = res[i].js_amt;
                        ds[`js_sl_${i}`] = res[i].js_sl;
                        ds[`js_se_${i}`] = res[i].js_se;
                    }
                    form.setFieldsValue(ds);
                    setDjvalue({...invoice, ...ds});
                }
            }).finally(() => {
                setIsloading(false);
            })
        } else {
            form.resetFields();
        }
        return undefined;
    }, [invoice, fkey]);

    const reCalMoney = () => {
        let tot = 0;
        for (let i = 0; i < lycount; i++) {
            tot += Number(form.getFieldValue(`js_se_${i}`)) || 0;
        }
        form.setFieldValue('sum_se', tot.toFixed(2));
        setDjvalue(prev => ({ ...prev, amount_total: tot.toFixed(2) }))
    }

    const saveSubmit = async (sh) => {
        setIsloading(true);
        try {
            const values = await form.validateFields();
            console.log('校验通过', values, getobjkeys(values));

            const res = await webPost('zqdjsave', {
                ...values, id: invoice.id, lycount, sh
            });
            if (res) {
                message.success('保存成功');
                onSave && onSave();
            }
        } catch (errorInfo) {
            console.log('校验失败', errorInfo);
            message.error('请检查表单填写内容，有必填项未填或格式错误！');
            const firstErrorItem = document.querySelector('.ant-form-item-has-error');

            if (firstErrorItem) {
                firstErrorItem.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        } finally {
            setIsloading(false);
        }
        return;
    };
    const setDjvalue2 = (key, value) => {
        form.setFieldValue(key, value);
        setDjvalue((prev) => ({ ...prev, [key]: value }));
    }
    const reCalse = (key)=>{
        const v1 = Number(form.getFieldValue(`js_amt_${key}`)) || 0;
        const v2 = Number(form.getFieldValue(`js_sl_${key}`)) || 0;
        const v3 = Math.round(v1 * v2) / 100 ;
        console.log(key, v1,v2,v3);
        setDjvalue2(`js_se_${key}`, v3);
        reCalMoney();
    }
    return (
        <FullHeightLayout
            headerContent={null}
            footerContent={(<Row justify="center" style={{ width: '90%' }}>
                <Col>
                    <Button type="link" onClick={() => saveSubmit(0)}>保存为草稿</Button>
                    <Button onClick={() => saveSubmit(1)}>提交登记单</Button>
                </Col>
            </Row>)
            }
        >
            <Spin spinning={isloading}>
                <Form form={form} layout="vertical">
                    <h3>发票销售方信息</h3>
                    <div className='responsive-grid4'>
                        <Form.Item className="form-item-bordered" label="单位名称">{invoice.xs_dw}</Form.Item>
                        <Form.Item className="form-item-bordered" label="税号">{invoice.xs_sh}</Form.Item>
                        <Form.Item className="form-item-bordered" label="开户银行">{invoice.xs_khh}</Form.Item>
                        <Form.Item className="form-item-bordered" label="银行账号">{invoice.xs_yhzh}</Form.Item>
                        <Form.Item className="form-item-bordered" label="单位地址">{invoice.xs_dwdz}</Form.Item>
                        <Form.Item className="form-item-bordered" label="电话">{invoice.xs_tel}</Form.Item>
                    </div>
                    <h3>发票购买方信息</h3>
                    <div className='responsive-grid4'>
                        <Form.Item className="form-item-bordered" label="单位名称">{invoice.mf_dw}</Form.Item>
                        <Form.Item className="form-item-bordered" label="税号">{invoice.mf_sh}</Form.Item>
                        <Form.Item className="form-item-bordered" label="纳税人类型" name="mf_nsr"><Input /></Form.Item>
                        <Form.Item className="form-item-bordered" label="开户银行">{invoice.mf_khh}</Form.Item>
                        <Form.Item className="form-item-bordered" label="银行账号">{invoice.mf_yhzh}</Form.Item>
                        <Form.Item className="form-item-bordered" label="单位地址">{invoice.mf_dwdz}</Form.Item>
                        <Form.Item className="form-item-bordered" label="电话">{invoice.mf_tel}</Form.Item>
                    </div>
                    <h3>业务明细</h3>
                    <div className='responsive-grid4'>
                        <Form.Item className="form-item-bordered" label="开票申请单号">{invoice.isn}</Form.Item>
                        <Form.Item className="form-item-bordered" label="开票日期" name="make_date2" rules={[{ required: true }]}><DateInput /></Form.Item>
                        <Form.Item className="form-item-bordered" label="发票号码" name="invoice_no" rules={[{ required: true }]}>
                            <Input onChange={(e) => setDjvalue(prev => ({ ...prev, invoice_no: e.target.value }))} />
                        </Form.Item>
                        <Form.Item className="form-item-bordered" label="发票类型">{Number(invoice.fp_type) === 1 ? '电子专票' : '普票'}</Form.Item>
                        <Form.Item className="form-item-bordered" label="商品">{invoice.spmc}</Form.Item>
                        <Form.Item className="form-item-bordered" label="商品数量">{invoice.sp_sl}</Form.Item>
                        <Form.Item className="form-item-bordered" label="单价">{invoice.sp_sl}</Form.Item>
                        <Form.Item className="form-item-bordered" label="开票税率">{invoice.kpsl}%</Form.Item>
                        <Form.Item className="form-item-bordered" label="不含税金额" name="bhsje">{invoice.bhsje}</Form.Item>
                        <Form.Item className="form-item-bordered" label="税额">{invoice.se}</Form.Item>
                        <Form.Item className="form-item-bordered" label="含税金额">{invoice.amount}</Form.Item>
                        <Form.Item className="form-item-bordered" label="项目编号">{invoice.sn}</Form.Item>
                        <Form.Item className="form-item-bordered" label="建筑项目名称">{invoice.jz_xm_mc}</Form.Item>
                        <Form.Item className="form-item-bordered" label="建筑服务发生地">{invoice.jz_fw_fd}</Form.Item>
                    </div>
                    <h3>预缴情况</h3>
                    <Form.Item name={`wjz_no`} hidden><Input /></Form.Item>
                    <Form.Item name="sum_se" hidden><Input /></Form.Item>
                    <table className='beautiful-table border-table'><tbody>
                        <tr>
                            <td>外经证编号</td>
                            <td><Input value={djvalue?.wjz_no} onChange={(e) => setDjvalue2('wjz_no', e.target.value)} /></td>
                            <td>发票号码</td><td>{djvalue?.invoice_no}</td>
                            <td>应收税款</td><td>{invoice.amount_sj}</td>
                            <td>预缴合计</td><td>{djvalue?.amount_total}</td>
                        </tr>
                        {
                            Array.from({ length: lycount }, (_, index) => (
                                <tr>
                                    <td>
                                        <Form.Item name={`wjz_no_${index}`} hidden><Input /></Form.Item>
                                        <Input value={djvalue?.[`wjz_no_${index}`]} onChange={(e) => setDjvalue2(`wjz_no_${index}`, e.target.value)} />
                                    </td>
                                    <td><Form.Item name={`szlx_${index}`} hidden><Input /></Form.Item>
                                        <Select
                                            value={djvalue?.[`szlx_${index}`]}
                                            options={taxOptions}
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.label.toLowerCase().includes(input.toLowerCase())
                                            }
                                            style={{ width: 240 }}
                                            onChange={(v) => setDjvalue2(`szlx_${index}`, v)}
                                        /></td>
                                    <td>计税金额</td><td><Form.Item name={`js_amt_${index}`} hidden><Input /></Form.Item>
                                        <InputNumber style={{width:'100%'}} value={djvalue?.[`js_amt_${index}`]} onChange={(v) => {setDjvalue2(`js_amt_${index}`, v);reCalse(index)}} />
                                    </td>
                                    <td>税率（%）</td><td><Form.Item name={`js_sl_${index}`} hidden><Input /></Form.Item>
                                        <InputNumber value={djvalue?.[`js_sl_${index}`]} onChange={(v) => {setDjvalue2(`js_sl_${index}`, v);reCalse(index)}} />
                                    </td>
                                    <td>税额</td><td><Form.Item name={`js_se_${index}`} hidden><Input /></Form.Item>
                                        <InputNumber  style={{ width: '100%' }} value={djvalue?.[`js_se_${index}`]}
                                            onChange={(v) => { setDjvalue2(`js_se_${index}`, v); reCalMoney() }} />
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody></table>

                    <div className='responsive-grid' style={{ 'marginTop': '10px' }}>
                        <Form.Item label={<a onClick={() => { setLycount(prev => (1 + prev)); }}>增加预缴</a>} ></Form.Item>
                        <Form.Item label={<a onClick={() => { setLycount(prev => (Math.max(prev - 1, 1))); }}>预缴-1</a>} ></Form.Item>
                    </div>


                </Form >
            </Spin>
        </FullHeightLayout >
    );
};

export default ZqdjForm;